import {groupKey} from '../../../services/groups/groupModel';
import React, {useEffect, useState} from 'react';
import {Grid, Typography} from "@mui/material";
import GroupCard from "../GroupCard/GroupCard";
import classes from "./GroupsListSelect.module.scss";
import {Group} from "../../../services/groups/groupModel";
import {AddProp} from '../../../hooks/helpers';
import {Voidlllustration} from "../../../assets/ilustrations/VoidIlustration/Voidlllustration";

interface LegacyGroupsListSelectProps {
  groups?: Group[];
  updateCurrentGroup: (group: Group) => void;
}

interface CreationGroupsListSelectProps {
  groups: Group[];
  updateCurrentGroup: (group: Group) => void;
  selectedGroupName?: string;
  variant: 'creation';
}

type GroupsListSelectProps = CreationGroupsListSelectProps | (LegacyGroupsListSelectProps & {variant?: 'legacy'});

const CreationGroupsListSelect = (props: CreationGroupsListSelectProps) => {
  const {groups, updateCurrentGroup, selectedGroupName} = props;
  const [internalSelectedName, setInternalSelectedName] = useState<string>();
  // Explicit undefined is a controlled empty selection, not an uncontrolled selector.
  const controlled = 'selectedGroupName' in props;
  const currentName = controlled ? selectedGroupName : internalSelectedName;

  return (
    <div className={classes['creation-list']} role="group" aria-label="Choose a group">
      {groups.map(group => (
        <GroupCard
          key={groupKey(group)}
          group={group}
          type="creation"
          isSelected={groupKey(group) === currentName}
          onClick={() => {
            if (!controlled) setInternalSelectedName(groupKey(group));
            updateCurrentGroup(group);
          }}
        />
      ))}
    </div>
  );
};

const LegacyGroupsListSelect = ({groups, updateCurrentGroup}: LegacyGroupsListSelectProps) => {

  type GroupSelected = AddProp<Group, { isSelected: boolean }>

  const [groupsSelected, setGroupSelected] = useState<GroupSelected[]>()

  const loadingGroups = Array(8).fill(undefined);

  useEffect(() => {
    if (!groups) setGroupSelected(loadingGroups);

    setGroupSelected(groups?.map((group) => ({
      ...group,
      isSelected: false,
    })))
  }, [groups])

  const handleClick = (group: Group) => {
    setGroupSelected((groupsSelected || []).map(g => ({...g, isSelected: g === group})));
    updateCurrentGroup(group);
  };

  if (groupsSelected === undefined || groupsSelected.length === 0) {
    return <div>
      <Voidlllustration classname={classes['void-illustration']}></Voidlllustration>
      <Typography sx={{display: 'flex', justifyContent: 'center', marginBottom: '10px'}} variant='caption'>
        No groups available!

      </Typography>
    </div>
  }

  return (
    <Grid container spacing={3} className={classes['group-list-select']}>
      {(groupsSelected || loadingGroups).map(group =>
        <Grid item xs={6} sm={4} md={2} key={group?.name}>
          <div className={classes['group-card']}>
            <GroupCard group={group} key={group?.name} type='selected' isSelected={group?.isSelected}
                       onClick={() => handleClick(group)}/>
          </div>
        </Grid>
      )}
    </Grid>
  );
};

const GroupsListSelect = (props: GroupsListSelectProps) => props.variant === 'creation'
  ? <CreationGroupsListSelect {...props}/>
  : <LegacyGroupsListSelect {...props}/>;

export default GroupsListSelect;
